import React from "react";
import config from 'appConfig';
import { getImageUrl } from "../../services/asset";

export interface IndexImageProps {
  alt: string;
  src: string;
  onError?: (e: React.InvalidEvent<HTMLImageElement>) => void;
}

const IndexImage = (props: IndexImageProps): JSX.Element => {
  const { alt, onError } = props;
  return <img alt={alt} onError={onError} {...props} />;
}

IndexImage.defaultProps = {
  onError: (e: React.InvalidEvent<HTMLImageElement>) => {
    const placeholderImageSrc = getImageUrl(config.imagePlaceholder);
    if (e.target.src.trim() !== placeholderImageSrc) {
      e.target.src = placeholderImageSrc;
    }
  }
};

export default IndexImage;



// WEBPACK FOOTER //
// ./src/containers/IndexImage/index.tsx